import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ObjectApiInterface } from '../base/interfaces/object-api.interface';
import {
  DefaultSupervisionAssignPayload,
  DefaultSupervisionDependencies,
  DefaultSupervisionMetrikTypeEnum,
  DefaultSupervisionReplaceContactPayload,
  DefaultSupervisionResolvedLine,
  DefaultSupervisionTreeNode,
  DefaultSupervisionUnassignPayload,
} from '../models/default-supervision.model';

/**
 * Configuration des acteurs « Supervision métier » par défaut (PRED-3061) :
 * arborescence Tenant/Établissement, affectation par nœud, propagation aux Metrik,
 * impacts et remplacement d'un contact référencé.
 */
@Injectable({
  providedIn: 'root',
})
export class DefaultSupervisionService {
  baseUrlApi = '/api/default-supervision';

  constructor(public http: HttpClient) {}

  getTree(establishmentId?: string): Observable<ObjectApiInterface<DefaultSupervisionTreeNode[]>> {
    let params = new HttpParams();
    if (establishmentId) {
      params = params.set('establishmentId', establishmentId);
    }
    return this.http.get<ObjectApiInterface<DefaultSupervisionTreeNode[]>>(`${this.baseUrlApi}/tree`, { params });
  }

  /**
   * Restitution du superviseur par défaut résolu d'une Metrik (une ligne par établissement) :
   * utilisé par le composant partagé des fiches bâtiment/équipement.
   */
  resolveLines(
    metrikType: DefaultSupervisionMetrikTypeEnum,
    genericNodeId: string,
    establishments?: { _id: string; label: string }[],
  ): Observable<ObjectApiInterface<DefaultSupervisionResolvedLine[]>> {
    return this.http.post<ObjectApiInterface<DefaultSupervisionResolvedLine[]>>(`${this.baseUrlApi}/resolve`, {
      metrikType,
      genericNodeId,
      establishments,
    });
  }

  assign(payload: DefaultSupervisionAssignPayload): Observable<ObjectApiInterface<any>> {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/assign`, payload);
  }

  unassign(payload: DefaultSupervisionUnassignPayload): Observable<ObjectApiInterface<any>> {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/unassign`, payload);
  }

  checkContactDependencies(
    contactId: string,
    establishmentId?: string,
  ): Observable<ObjectApiInterface<DefaultSupervisionDependencies>> {
    let params = new HttpParams();
    if (establishmentId) {
      params = params.set('establishmentId', establishmentId);
    }
    return this.http.post<ObjectApiInterface<DefaultSupervisionDependencies>>(
      `${this.baseUrlApi}/checkContactDependencies/${contactId}`,
      {},
      { params },
    );
  }

  replaceContact(payload: DefaultSupervisionReplaceContactPayload): Observable<ObjectApiInterface<any>> {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/replaceContact`, payload);
  }
}
